import { Log } from "@fanfanlo";

const fileLog = new Log(false, 'description_utils_validateUrl');
fileLog.pause = true;
fileLog.childrenPaused = true;

/**
 * 验证URL是否有效且安全
 * @param url 待验证的URL
 * @returns 是否有效
 */
export function validateUrl(url: string): boolean {
    const fnLog = fileLog.sub(false, 'validateUrl_fn');
    fnLog.pause = true;

    fnLog.log('开始验证URL:', url);

    if (!url) {
        fnLog.log('URL为空');
        return false;
    }

    if (typeof url !== 'string') {
        fnLog.log('URL类型不是string:', typeof url);
        return false;
    }

    const trimmedUrl = url.trim();
    fnLog.log('去除空格后的URL:', trimmedUrl);

    if (trimmedUrl.length === 0) {
        fnLog.log('去除空格后URL为空');
        return false;
    }

    // 检查协议（仅允许http和https）
    const hasHttpProtocol = trimmedUrl.startsWith('http://');
    const hasHttpsProtocol = trimmedUrl.startsWith('https://');
    fnLog.log('是否http协议:', hasHttpProtocol, '是否https协议:', hasHttpsProtocol);

    if (!hasHttpProtocol && !hasHttpsProtocol) {
        fnLog.log('URL协议不是http或https');
        return false;
    }

    // 尝试使用URL API验证
    let urlObj: URL | null = null;
    try {
        urlObj = new URL(trimmedUrl);
        fnLog.log('URL解析成功:', urlObj.href);
    } catch (e) {
        fnLog.error('URL解析失败:', e);
        return false;
    }

    if (urlObj === null) {
        fnLog.log('URL对象为null');
        return false;
    }

    // 再次确认协议
    const protocol = urlObj.protocol;
    fnLog.log('URL协议:', protocol);

    const isValid = protocol === 'http:' || protocol === 'https:';
    fnLog.log('URL是否有效:', isValid);

    return isValid;
}
